export default __webpack_public_path__ + "static/media/36I-102698_-15664_0.d2c29ad4.jpg";